import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CSSModules from 'react-css-modules';

import CtaButton from '../common/cta-button';

import styles from './project.module.scss';

const Project = ({ name, description, linkText, linkUrl, hasButton, backgroundColor, ...opts }) => (
  <div styleName={classnames('container', backgroundColor)} {...opts}>
    <div className="grid-y" styleName="padder">
      <div className="cell shrink">
        <h3>{name}</h3>
      </div>
      <div className="cell" styleName="flex-grow">
        <p>{description}</p>
      </div>
      <div className="cell shrink">{hasButton && <CtaButton to={linkUrl}>{linkText}</CtaButton>}</div>
    </div>
  </div>
);
Project.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  backgroundColor: PropTypes.string,
  hasButton: PropTypes.bool,
};
Project.defaultProps = {
  name: '',
  description: '',
  linkText: '',
  linkUrl: '',
  hasButton: false,
  backgroundColor: 'azure',
};

export const ProjectType = PropTypes.shape(Project.propTypes);

export default CSSModules(Project, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/portfolio/project.jsx